import { Theme } from 'morpheus-ui';
import { tv } from 'tailwind-variants';

const selectGroupClasses = tv({
  base: 'flex flex-col w-full bg-mono-color-white rounded-md',
  variants: {
    size: {
      md: '',
      lg: '',
    },
    disabled: {
      true: '',
    },
  },
});

const listBoxClasses = tv({
  base: 'relative',
  variants: {
    size: {
      md: '',
      lg: '',
    },
    disabled: {
      true: '',
    },
  },
});

const borderWidthKeys = Object.keys(Theme.borderWidth);
const listBoxButtonClasses = tv(
  {
    base: 'text-mono-color-black peer flex gap-xs justify-between p-3 text-left items-center rounded-md border-hairline border-mono-color-dark w-full ui-open:border-brand-color-primary-pure ui-open:shadow-focused transition-all',
    variants: {
      size: {
        md: 'p-3 text-md',
        lg: 'p-4 text-lg',
      },
      disabled: {
        true: 'cursor-not-allowed text-mono-color-black bg-mono-300',
      },
      hasError: {
        true: 'border-error-500 shadow-error ui-open:border-error-500 ui-open:shadow-error',
      },
    },
  },
  {
    twMergeConfig: {
      theme: {
        borderWidth: borderWidthKeys,
      },
    },
  }
);

const listBoxButtonIconClasses = tv({
  base: '',
});

const labelClasses = tv({
  base: 'text-mono-color-black text-sm absolute bg-gradient-to-b from-color-transparent from-42.28% via-mono-color-white via-43.53% to-mono-color-white to-52.68% px-1 transition-all select-none pointer-events-none',
  variants: {
    size: {
      md: `
        left-3
        -top-2 
        
        ui-open:-top-2
        ui-open:text-sm   
    `,
      lg: `
        left-3
        -top-2

        ui-open:-top-2
        ui-open:text-sm   
      `,
    },
    disabled: {
      true: 'text-mono-color-black',
    },
    isSelected: {
      true: '',
    },
    hasError: {
      true: 'text-error-500 ui-not-open:text-black',
    },
  },
  compoundVariants: [
    {
      hasError: true,
      isSelected: true,
      className: 'text-error-500 ui-not-open:text-error-500',
    },
    {
      disabled: true,
      isSelected: false,
      className: 'bg-none',
    },
    {
      disabled: true,
      isSelected: true,
      className:
        'bg-gradient-to-b from-transparent from-42.28% via-mono-300 via-43.53% to-mono-300 to-52.68%',
    },
    {
      isSelected: false,
      size: 'lg',
      className: 'text-lg top-3.5',
    },
    {
      isSelected: false,
      size: 'md',
      className: 'text-md top-3.5',
    },
  ],
});

const helperTextClasses = tv({
  base: 'text-sm text-mono-color-dark pt-1 ml-2 focus:text-mono-color-black  ui-not-open:text-mono-color-dark ui-open:text-mono-color-black',
  variants: {
    disabled: {
      true: 'text-mono-700',
    },
  },
});
const errorTextClasses = tv({
  base: 'text-sm text-feedback-color-error-pure pt-1 ml-2 focus:text-black ui-open:text-red-500',
  variants: {
    disabled: {
      true: 'text-mono-700',
    },
  },
});

const listBoxOptionsClasses = tv({
  base: 'flex flex-col gap-1 p-2 mt-2 bg-mono-color-white rounded-md shadow-level-2 absolute z-10 w-full overflow-y-auto max-h-80',
  variants: {
    size: {
      md: 'text-md',
      lg: 'text-lg',
    },
    disabled: {
      true: '',
    },
  },
});

const listBoxOptionClasses = tv({
  base: 'text-mono-color-darkest bg-color-lighter p-4 cursor-pointer transition-all select-none rounded-md flex flex-row items-center',
  variants: {
    disabled: {
      true: '',
    },
    active: {
      true: '',
    },
    selected: {
      true: 'bg-brand-color-primary-lighter text-brand-color-primary-pure',
    },
  },
});

export {
  errorTextClasses,
  helperTextClasses,
  labelClasses,
  listBoxButtonClasses,
  listBoxButtonIconClasses,
  listBoxClasses,
  listBoxOptionClasses,
  listBoxOptionsClasses,
  selectGroupClasses,
};
